import { Grid, StepperLines, Text } from '@approvalmax/ui/src/components';

import { Controls } from '../resources/components';
import { StepForm } from './resources/components';
import { messages } from './resources/messages';

const Page = () => {
    return (
        <Grid gap={24}>
            <StepperLines currentStep={2} stepsCount={3} color='cobalt100' />

            <Grid gap={16}>
                <Text font='headline' fontSize='xxsmall' fontWeight='medium'>
                    {messages.title}
                </Text>

                <StepForm />
            </Grid>

            <Controls />
        </Grid>
    );
};

export default Page;
